import clsx from "clsx";
import { Notification, Switch } from "@k8slens/lds";

import styles from "./Use2FASwitch.module.css";

type Props = {
  twoFactorAuthEnabled: boolean;
  setTwoFactorAuthEnabled(enabled: boolean): void;
  loading: boolean;
  error?: string | null;
  disabled?: boolean;
};

export const Use2FASwitch = ({ twoFactorAuthEnabled, loading, setTwoFactorAuthEnabled, error, disabled }: Props) => {
  return (
    <section className={styles.use2faSwitchWrapper}>
      <section className="self-center">
        <h3 className={clsx("lds-form-label lds-form-field--label", styles.switchLabel)}>Two-Factor Authentication</h3>
        <p className={clsx("lds-form-switch-group--description", styles.switchDescription)}>
          Protect your Lens ID with an extra layer of security. Once enabled, you’ll be asked to configure two-factor
          authentication during your next login. After setup, you’ll need a code from your mobile device to log in.
        </p>
        {error && typeof error === "string" ? (
          <Notification level="error" message={error} type="closable" className="my-5" />
        ) : null}
      </section>
      <Switch
        className={styles.switch}
        disabled={disabled}
        onChange={(newchecked) => {
          setTwoFactorAuthEnabled(newchecked);
        }}
        checked={twoFactorAuthEnabled}
      />
    </section>
  );
};
